import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-[#0f0a1a] text-gray-300">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-pink-400 hover:text-pink-300 mb-8" data-testid="refund-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-white mb-2">Refund Policy</h1>
        <p className="text-gray-500 text-sm mb-8">Last updated: January 1, 2025</p>

        <div className="space-y-6 leading-relaxed text-sm">
          <section className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-red-400 mb-2">ALL SALES ARE FINAL — NO REFUNDS</h2>
            <p className="text-gray-200">All purchases made on this website are strictly non-refundable. By completing a purchase, you acknowledge and agree that no refunds, returns, exchanges, credits, or chargebacks will be issued under any circumstances.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Digital Products</h2>
            <p>All products sold on this website — including but not limited to eBooks, digital courses, and educational content — are digital in nature. Once a purchase is confirmed and access is granted, the transaction is final and irreversible. Due to the instant-access nature of digital goods, it is impossible to "return" the product, and therefore no refund will be provided.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. No Exceptions</h2>
            <p>Refunds will not be granted for any reason, including but not limited to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>Change of mind after purchase.</li>
              <li>Dissatisfaction with the content.</li>
              <li>Failure to access the content due to personal device or internet issues.</li>
              <li>Duplicate purchases — it is the buyer's responsibility to verify before purchasing.</li>
              <li>Inability to complete the course or read the book.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Buyer's Responsibility</h2>
            <p>By proceeding with any purchase on this website, you confirm that you have read, understood, and fully accepted this No-Refund Policy. You waive any right to dispute or reverse the charge through your payment provider. Any attempt to initiate a chargeback or payment dispute will be considered a violation of these terms and may result in permanent account suspension and legal action.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Donations</h2>
            <p>All charitable donations made through this platform are final and non-refundable.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Contact</h2>
            <p>For questions regarding this policy, contact us via WhatsApp at <a href="https://wa.me/963988242654" className="text-green-400 hover:text-green-300">+963 988 242 654</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
